export default {"src":"/_next/static/media/bo.1407444e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};